/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:40:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import { encryptRSA } from '@root/shared/rsa';
import { http } from '@shared';

const terminalId = 'asdfiwoo21wewfsf1555y';
const terminalName = 'huawei 1255';
const terminalModelName = 'bbbbsdsfs';
// const username = 'hejun@leedarson.com';
// const password = 'Qq123456';
// const username = 'chenchaoqiang@leedarson.com';
// const password = 'Aa123456';
const phoneId =
  'a239e8911aea1a9abb8193e41b972e7a16f2c9c0ea7f47384d496e170d2d9123';
const os = 2;
const appVersion = '1.0.0';
const osVersion = '12.0.0';
const webVersion = '0.0.1';
const webViewVersion = '0.0.1';
const area = 'Asia/Shanghai';
const countryKey = 'region:BRAA';

const loginApi = ({
  username,
  password,
}: {
  username: string;
  password: string;
}) => {
  return http.request({
    url: `/apiLogin/users/loginWithFreeVerification`,
    method: 'post',
    data: {
      username,
      password: encryptRSA(password),
    },
    timeout: 20000, // 云端耗时较长
  });
};

export interface ICertificationCode {
  code: string;
  secondaryCertificationSign: string;
}

export const loginCertificationCode = async (data: ICertificationCode) => {
  return http.request({
    url: `/apiLogin/users/verifySecondCertification`,
    method: 'post',
    data,
    timeout: 20000, // 云端耗时较长
  });
};

/**
 *   二次登陆 - 重发验证码
 */
export const resendSecondCertification = (
  secondaryCertificationSign: string,
) => {
  return http.request({
    url: `/apiLogin/users/resendSecondCertification`,
    method: 'post',
    data: { secondaryCertificationSign },
    timeout: 20000, // 云端耗时较长
  });
};

export default loginApi;
